import { useNavigate } from 'react-router-dom';
import { useAnalytics } from '@backstage/core-plugin-api';
import type { TemplateEntityV1beta3 } from '@backstage/plugin-scaffolder-common';
import Button from '@material-ui/core/Button';

export function ViewButton({ entityLink }: { entityLink: string }) {
  const navigate = useNavigate();

  return (
    <Button variant="outlined" color="primary" size="small" onClick={() => navigate(entityLink)}>
      View
    </Button>
  );
}

export function LaunchButton({
  template,
  onSelected,
}: {
  template: TemplateEntityV1beta3;
  onSelected?: (template: TemplateEntityV1beta3) => void;
}) {
  const analytics = useAnalytics();

  const handleLaunch = () => {
    analytics.captureEvent('click', 'Template has been opened');
    onSelected?.(template);
  };

  return (
    <Button size="small" variant="outlined" color="primary" onClick={handleLaunch}>
      Launch
    </Button>
  );
}
